"use strict";
var pushNotification = function(posTop, posRight, title, description, type) {
    var newElement = document.createElement("div");
    var logoElement = document.querySelector(".logo");
    newElement.setAttribute("class", "notification ".concat(type));
    var htmlBlock = '\n    <h2 class="title">'.concat(title, "</h2>\n    <p>").concat(description, "</p>\n  ");
    newElement.innerHTML = htmlBlock;
    newElement.style.top = "".concat(posTop, "px");
    newElement.style.right = "".concat(posRight, "px");
    logoElement.after(newElement);
    setTimeout(function() {
        newElement.style.display = "none";
    }, 2000);
};
pushNotification(10, 10, "Title of Success message", "Message example.\n Notification should contain title and description.", "success");
pushNotification(150, 10, "Title of Error message", "Message example.\n Notification should contain title and description.", "error");
pushNotification(290, 10, "Title of Warning message", "Message example.\n Notification should contain title and description.", "warning");

//# sourceMappingURL=index.854c8f81.js.map
